





































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Resource } from '@/store/modules/resource'
import { EventBus } from '@/utils/event-bus'
import { lookup } from 'mime-types'
import { saveAs } from 'file-saver'
import axios from 'axios'
import ResourcePreviewModal from '@/views/products/resources/ResourcePreview.modal.vue'
@Component({
  components: {
    ResourcePreviewModal
  }
})
export default class GVDReferences extends Vue {
  @Prop({ default: [] }) references!: Resource[]

  selectedResource: Resource | null = null

  allowPreview: boolean = process.env.ALLOWPREVIEW === 'true'

  refDomId: string = 'resource-preview-modal-ref'

  openReferencesModal () {
    this.$bvModal.show('all-references-modal')
  }

  getRefNum (reference: Resource) {
    return reference.gvdResourceNumbers.length ? `${reference.gvdResourceNumbers[0].number}.` : '1.'
  }

  get numberedReferences () {
    return this.references.filter((reference: Resource) => {
      return reference.gvdResourceNumbers.length
    })
  }

  get unnumberedReferences () {
    return this.references.filter((reference: Resource) => {
      return !reference.gvdResourceNumbers.length
    })
  }

  get hasReferences () {
    return this.numberedReferences.length || this.unnumberedReferences.length
  }

  async downloadFile (resource: Resource) {
    if (this.allowPreview && (resource.fileExt === 'png' || resource.fileExt === 'pdf' || resource.fileExt === 'jpg')) {
      this.selectedResource = resource
      this.$bvModal.show(this.refDomId)
    } else {
      EventBus.$emit('show-loader')
      const resp = await axios.get(`resources/download/${resource.key}`, { withCredentials: true, responseType: 'blob' })
      if (!resp || resp.status !== 200) {
        EventBus.$emit('hide-loader')
        return
      }
      this.$store.dispatch('addEvent', { description: 'Resource download', data: { key: resource.key }, title: 'Resource download', eventType: 3, userAgent: navigator.userAgent, product: null, market: { key: this.$store.getters.getSelectedMarket }, trackingKey: resource.trackingKey })

      const _blob = new Blob([resp.data], { type: lookup(resource.filename as string) || undefined })
      saveAs(_blob, resource.filename)
      EventBus.$emit('hide-loader')
    }
  }
}
